import { useState } from "react";
import { toast } from "sonner";
import { Check } from "lucide-react";
import { api } from "@/lib/api";

const field = "w-full bg-transparent border-b border-espresso/25 py-3 text-espresso placeholder:text-mocha/70 focus:outline-none focus:border-gold transition-colors";

const StarPicker = ({ value, onChange }) => {
  const [hover, setHover] = useState(0);
  return (
    <div className="flex gap-1" onMouseLeave={() => setHover(0)} role="radiogroup" aria-label="Rating">
      {[1, 2, 3, 4, 5].map((n) => (
        <button type="button" key={n} data-testid={`review-star-${n}`} aria-label={`${n} stars`} onMouseEnter={() => setHover(n)} onClick={() => onChange(n)}
          className={`text-3xl leading-none transition-colors duration-200 ${(hover || value) >= n ? "text-gold" : "text-espresso/20"}`}>
          ★
        </button>
      ))}
    </div>
  );
};

export const ReviewForm = () => {
  const [f, setF] = useState({ name: "", email: "", occasion: "", message: "" });
  const [rating, setRating] = useState(5);
  const [state, setState] = useState("idle");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    try {
      await api.post("/reviews", { ...f, email: f.email || null, rating });
      setState("done");
    } catch {
      setState("idle");
      toast.error("Please check your details and try again.");
    }
  };

  if (state === "done")
    return (
      <div data-testid="review-form-success" className="py-10">
        <span className="w-14 h-14 rounded-full border border-gold flex items-center justify-center text-gold"><Check className="w-6 h-6" strokeWidth={1.4} /></span>
        <p className="font-display text-4xl mt-8">Thank you, {f.name.split(" ")[0]}.</p>
        <p className="text-mocha mt-4 max-w-md">Your kind words mean the world. Lise will read every one.</p>
      </div>
    );

  return (
    <form data-testid="review-form" onSubmit={submit} className="grid sm:grid-cols-2 gap-x-8 gap-y-8">
      <div className="sm:col-span-2">
        <span className="eyebrow">Your rating</span>
        <div className="mt-3"><StarPicker value={rating} onChange={setRating} /></div>
      </div>
      <label className="block"><span className="eyebrow">First name *</span>
        <input data-testid="review-name" required maxLength={80} value={f.name} onChange={set("name")} className={field} /></label>
      <label className="block"><span className="eyebrow">What did you order?</span>
        <input data-testid="review-occasion" maxLength={80} value={f.occasion} onChange={set("occasion")} className={field} placeholder="e.g. Cupcakes for a birthday" /></label>
      <label className="block sm:col-span-2"><span className="eyebrow">Your review *</span>
        <textarea data-testid="review-message" required minLength={5} maxLength={1500} rows={4} value={f.message} onChange={set("message")} className={`${field} resize-none`} /></label>
      <label className="block sm:col-span-2"><span className="eyebrow">Email (optional, never shown)</span>
        <input data-testid="review-email" type="email" value={f.email} onChange={set("email")} className={field} /></label>
      <div className="sm:col-span-2">
        <button data-testid="review-submit" disabled={state === "sending"} className="btn btn-dark">{state === "sending" ? "Sending…" : "Share Your Review"}</button>
      </div>
    </form>
  );
};
